<template>
  <div v-if="importantNoticeData.title" class="notice-bar">
    <div class="notice-bar-left">
      <span class="notice-bar-title"><span class="iconfont icon-zhihuixiaofang-jingbaoguzhang" />
        {{ $t('home.importantReminder') }}：</span>
      <div class="notice-bar-content">
        <span class="marquee-text">{{ importantNoticeData.title }}</span>
      </div>
    </div>
    <div class="notice-bar-btn" @click="handleView">{{ $t('home.viewNow') }}</div>
    <!-- 系统消息弹框 -->
    <systemMessagePopUp ref="systemMessagePopUpRef" @readMessage="onReadMessage" />
  </div>
</template>

<script>
import { getImportantRemindBanner } from '@/api/newExpressAPI';
import systemMessagePopUp from '@/components/systemMessagePopUp/index.vue';

export default {
  components: {
    systemMessagePopUp
  },
  data() {
    return {
      importantNoticeData: {}
    };
  },
  computed: {
    // 走马灯展示文本：摘要 + 正文
    marqueeText() {
      const { abstract, text } = this.importantNoticeData || {};
      const parts = [abstract, text].filter(Boolean);
      return parts.length ? parts.join('  ') : '暂无重要提醒';
    }
  },
  mounted() {
    this.getImportantNotice();
  },
  methods: {
    // 获取重要提醒横幅
    async getImportantNotice() {
      const data = {
        systemType: 1
      };
      try {
        const result = await getImportantRemindBanner(data);
        if (result.code === 200) {
          this.importantNoticeData = result.data || {};
        }
      } catch (error) {
        console.error('获取重要提醒横幅失败:', error);
      }
    },
    // 立即查看：把重要提醒对象传给系统消息弹框（跳过已读接口）
    handleView() {
      const d = this.importantNoticeData || {};
      const messageObj = {
        title: d.title || d.zhTitle || d.abstract || '重要提醒',
        text: d.text || d.content || '',
        textUrl: d.textUrl || '',
        createTime: d.createTime || '',
        msgTypeDesc: d.msgTypeDesc || '重要提醒',
        ...d
      };
      this.$refs.systemMessagePopUpRef.openDialog(messageObj, { skipRead: true });
    },
    // 消息已读回调（此处无需刷新，保留占位）
    onReadMessage() {}
  }
};
</script>

<style scoped>
/* ========= 顶部重要提醒横幅 ========= */
.notice-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffe8e8;
  border: 1px solid #ffd4d4;
  border-radius: 6px;
  padding: 8px 16px;
  margin: 10px 0;
  font-size: 13px;
  color: #5b1f1f;
  box-sizing: border-box;
}

.notice-bar-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  gap: 4px;
}

.notice-bar-title {
  flex-shrink: 0;
  color: #ee3535;
  font-weight: 600;
  white-space: nowrap;
}

.notice-bar-title .el-icon-warning-outline {
  margin-right: 4px;
}

.notice-bar-content {
  flex: 1;
  min-width: 0;
  color: #5b1f1f;
  white-space: nowrap;
  overflow: hidden;
}

.notice-bar-content .marquee-text {
  display: inline-block;
  padding-left: 100%;
  white-space: nowrap;
  animation: notice-marquee 25s linear infinite;
}

@keyframes notice-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.notice-bar-btn {
  background: #ee3535;
  color: #fff;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
}

.notice-bar-btn:hover {
  background: #d82828;
}
</style>
